// Central content + asset references for Divinities Children's Cove

export const BRAND = {
  name: "Divinities Children's Cove",
  short: "Divinities Cove",
  tagline: "Where Little Souls Learn, Grow, and Shine.",
  rooted: "Rooted in Love, Learning, Community & Indigenous Wisdom",
  logo: "https://customer-assets-4nw71qhi.emergentagent.net/job_450a435f-7069-4279-b120-94d21fd6f28e/artifacts/xf5d5i1e_IMG_6965.jpeg",
};

export const CONTACT = {
  phone: "(717) 934-0458",
  email: "",
  address: "",
  hours: [
    { day: "Weekdays (Mon–Fri)", time: "7:45 AM – 7:00 PM" },
    { day: "Saturday", time: "10:00 AM – 8:00 PM" },
    { day: "Sunday", time: "12:00 PM – 6:00 PM" },
  ],
};

// Friendly guide mascots (from the logo family)
export const GUIDES = {
  wave: "https://static.prod-images.emergentagent.com/jobs/450a435f-7069-4279-b120-94d21fd6f28e/images/d83a1b4a10de97d7efc69eb29de13c3ac25c2dcdc62f0fd0756651bcb9926394.jpeg",
  leaf: "https://static.prod-images.emergentagent.com/jobs/450a435f-7069-4279-b120-94d21fd6f28e/images/fa5f63d1a97bf84292f30e8ea9cd315c098cc66d4219cd00201482bc2b142cbb.jpeg",
  book: "https://static.prod-images.emergentagent.com/jobs/450a435f-7069-4279-b120-94d21fd6f28e/images/1118f5fd63823c1223efb5271badae9863fa9045b366f3b80a6c2dbbd8291bd0.jpeg",
  point: "https://static.prod-images.emergentagent.com/jobs/450a435f-7069-4279-b120-94d21fd6f28e/images/7a684f5048ad4ca55ad819071e732a8e0c0ce259cc67df6f13db8424cd0b9c47.jpeg",
};

export const PHOTOS = {
  heroPlay: "https://images.pexels.com/photos/10044347/pexels-photo-10044347.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  flowers: "https://images.unsplash.com/photo-1650498438073-e98824700b85",
  forest: "https://images.unsplash.com/photo-1511448962213-2f9bc14ed197",
  binoculars: "https://images.unsplash.com/photo-1621293051751-6514b7f9515d",
  meals: "https://images.pexels.com/photos/8466773/pexels-photo-8466773.jpeg",
  gardening: "https://images.pexels.com/photos/23391569/pexels-photo-23391569.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  soilHands: "https://images.pexels.com/photos/36348358/pexels-photo-36348358.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  tugOfWar: "https://images.unsplash.com/photo-1720096971892-3e97a066ca7d",
};

export const PILLARS = [
  {
    key: "body",
    icon: "Sprout",
    emoji: "🌿",
    title: "Body",
    color: "#84A98C",
    tint: "#eef4ef",
    blurb: "Physical health, movement, nutrition, practical life skills & wellness.",
    detail:
      "We nourish children's physical well-being through movement, fresh home-cooked organic meals, outdoor exploration, gardening, practical life skills, cooking, rest, and healthy daily rhythms. We teach children to honor and care for their bodies while building healthy habits that support lifelong wellness.",
  },
  {
    key: "mind",
    icon: "Brain",
    emoji: "🧠",
    title: "Mind",
    color: "#4A90E2",
    tint: "#eaf2fc",
    blurb: "Curiosity, literacy, math, science, creativity & critical thinking.",
    detail:
      "We cultivate curiosity and a love of learning through literacy, mathematics, science, history, problem-solving, creativity, observation, and hands-on exploration. By following each child's unique interests and natural learning style, we encourage critical thinking, confidence, and joyful discovery.",
  },
  {
    key: "heart",
    icon: "Heart",
    emoji: "❤️",
    title: "Heart",
    color: "#E76F81",
    tint: "#fdeef1",
    blurb: "Empathy, confidence, healthy relationships, communication & resilience.",
    detail:
      "We foster emotional intelligence by helping children develop confidence, empathy, compassion, gratitude, communication skills, healthy relationships, emotional regulation, resilience, and a positive self-image. Children learn to express themselves with kindness, respect, and care for others while building healthy boundaries and meaningful connections.",
  },
  {
    key: "soul",
    icon: "Sparkles",
    emoji: "✨",
    title: "Soul",
    color: "#B983FF",
    tint: "#f4edff",
    blurb: "Identity, purpose, intuition, imagination, inner wisdom & self-discovery.",
    detail:
      "Every child is born with unique gifts, purpose, and inner wisdom. Through mindfulness, storytelling, creative expression, and reflection, children are encouraged to trust themselves, honor their intuition, and discover who they are — nurturing a deep sense of belonging.",
  },
  {
    key: "spirit",
    icon: "Globe2",
    emoji: "🌎",
    title: "Spirit",
    color: "#F4A259",
    tint: "#fdf1e6",
    blurb: "Indigenous wisdom, connection to nature, gratitude & stewardship.",
    detail:
      "Through Indigenous teachings, cultural traditions, seasonal rhythms, gratitude, and a deep connection with nature, we nurture reverence for all living beings, environmental stewardship, and respect for the Earth — helping children recognize they are part of something greater than themselves.",
  },
];

export const PROGRAMS = [
  { title: "Unschooling Program", desc: "Child-led, nature-based learning that follows each child's curiosity.", icon: "Compass" },
  { title: "Holistic Early Childhood Education", desc: "Whole-child care nurturing Body, Mind, Heart, Soul & Spirit.", icon: "Baby" },
  { title: "Full-Time Childcare", desc: "Consistent, loving daily care with warm rhythms.", icon: "Sun" },
  { title: "Part-Time Childcare", desc: "Flexible days that fit your family's schedule.", icon: "CalendarDays" },
  { title: "Drop-In Childcare", desc: "Occasional care based on availability.", icon: "DoorOpen" },
  { title: "After-School Care", desc: "A calm, joyful landing spot after the school day.", icon: "Backpack" },
  { title: "Saturday Care", desc: "Weekend adventures and creative play.", icon: "Star" },
  { title: "Nature-Based Learning", desc: "Outdoor exploration & environmental stewardship.", icon: "TreePine" },
  { title: "Indigenous Cultural Education", desc: "Stories, teachings, and traditions rooted in respect.", icon: "Feather" },
  { title: "Religious & Universal Studies", desc: "Age-appropriate teachings honoring every family's beliefs.", icon: "BookOpen" },
  { title: "Cooking & Nutrition Classes", desc: "Fresh, organic, meat-free food made with love.", icon: "ChefHat" },
  { title: "Gardening & Practical Life Skills", desc: "Hands in the soil, real-life learning.", icon: "Sprout" },
  { title: "Creative Arts, Music & Movement", desc: "Self-expression through art, rhythm & dance.", icon: "Palette" },
  { title: "Seasonal & Cultural Celebrations", desc: "Marking the rhythms of the year together.", icon: "PartyPopper" },
  { title: "Community Service & Leadership", desc: "Growing confident, caring young leaders.", icon: "HandHeart" },
  { title: "Family Workshops & Events", desc: "Learning and growing alongside families.", icon: "Users" },
];

export const MEALS = [
  { name: "Breakfast", desc: "A warm, nourishing start to the day.", icon: "Sunrise" },
  { name: "Lunch", desc: "Fresh, home-cooked, plant-powered meals.", icon: "Utensils" },
  { name: "Snacks", desc: "Wholesome bites to fuel play & discovery.", icon: "Apple" },
  { name: "Dinner", desc: "A comforting close to the day together.", icon: "Soup" },
];

export const PHILOSOPHY_PRINCIPLES = [
  "Learning isn't linear.",
  "Play is meaningful learning.",
  "Questions are always encouraged.",
  "Curiosity leads the way.",
  "Every experience is a chance to grow.",
  "Children's voices and interests matter.",
  "Adults are guides & mentors, not lecturers.",
  "We value process over perfection.",
];

export const LOOP_VALUES = [
  "The child's curiosity over rigid timelines",
  "Learning through meaningful experiences",
  "Flexible routines with consistent rhythms",
  "Rest when children are tired",
  "Outdoor exploration",
  "Long periods of uninterrupted play",
  "Hands-on discovery",
  "Real-life experiences as education",
];

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Philosophy", to: "/philosophy" },
  { label: "Five Pillars", to: "/pillars" },
  { label: "Programs", to: "/programs" },
  { label: "A Day With Us", to: "/day" },
  { label: "Meals", to: "/meals" },
];
